"use client";

import React from "react";
import { useTranslations } from "next-intl";
import { FolderIcon } from "@/components/icons";

import { cn } from "@/src/lib/utils";

type NoDataCardProps = {
    title?: string;
    description?: string;
    className?: string;
    hideIcon?: boolean;
};

const NoDataCard: React.FC<NoDataCardProps> = ({
    title,
    description,
    className,
    hideIcon = true,
}) => {
    const t = useTranslations();
    const defaultTitle = title ?? t("label-no-data");
    const defaultDescription = description ?? t("label-nothing-found");
    return (
        <div
            className={cn(
                "m-3 rounded-md border bg-white p-6 text-center",
                className
            )}
        >
            {!hideIcon && (
                <div className="mx-auto flex h-10 w-10 items-center justify-center rounded-xl bg-muted/40">
                    <FolderIcon className="text-muted-foreground" size={20} />
                </div>
            )}

            <div className="mt-3 text-sm font-medium">{defaultTitle}</div>

            {defaultDescription ? (
                <div className="mt-1 text-xs text-muted-foreground">{defaultDescription}</div>
            ) : null}
        </div>
    );
};

export default NoDataCard;